/* Cyrus extras: comfort settings, sound, ambient background, quick search, share, quick-add bar,
   recently viewed, back to top, keyboard shortcuts and micro-interactions.
   Loads after Lenis and before cyrus.js (all deferred, so order is kept). */
(function () {
  'use strict';
  var doc = document, html = doc.documentElement, C = window.CYRUS || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || C.root || '/';
  var sysReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function $(s, el) { return (el || doc).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  var fmt; try { fmt = new Intl.NumberFormat(C.locale || 'en-GB', { style: 'currency', currency: C.currency || 'GBP' }); } catch (e) {}
  function money(v) { var n = Number(v) || 0; return fmt ? fmt.format(n) : '£' + n.toFixed(2); }
  function sized(u, w) {
    if (!u) return '';
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(toast.t);
    toast.t = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  var I = function (d) { return '<svg class="ic" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
  var ICON = {
    share: I('<path d="M12 15V3M7.5 7.5 12 3l4.5 4.5"/><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/>'),
    prev: I('<path d="M15 6l-6 6 6 6"/>'),
    next: I('<path d="M9 6l6 6-6 6"/>'),
    bag: I('<path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>')
  };

  /* ---------- saved preferences ---------- */
  var KEY = 'cyrus-prefs';
  var DEF = { ts: 0, sfx: true, bg: !sysReduce, calm: sysReduce, hc: false, rf: false, ul: false, fh: false, keys: true };
  var P = (function () {
    var o = {}; try { o = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) {}
    var r = {}; for (var k in DEF) r[k] = Object.prototype.hasOwnProperty.call(o, k) ? o[k] : DEF[k];
    return r;
  })();
  function save() { try { localStorage.setItem(KEY, JSON.stringify(P)); } catch (e) {} }
  function applyPrefs() {
    var k = html.classList;
    k.toggle('ts-1', P.ts === 1); k.toggle('ts-2', P.ts === 2);
    k.toggle('hc', !!P.hc); k.toggle('calm', !!P.calm); k.toggle('rf', !!P.rf);
    k.toggle('ul', !!P.ul); k.toggle('fh', !!P.fh);
    k.toggle('sfx-off', !P.sfx); k.toggle('bg-off', !P.bg || !!P.calm);
  }
  applyPrefs();

  /* ---------- smooth scrolling hook: keep a handle on Lenis, or skip it when motion is reduced ---------- */
  if (window.Lenis) {
    if (P.calm) window.Lenis = undefined;
    else {
      var L0 = window.Lenis;
      var LW = function (o) { var inst = new L0(o); window.__cyrusLenis = inst; return inst; };
      LW.prototype = L0.prototype;
      window.Lenis = LW;
    }
  }
  function lenis() { var l = window.__cyrusLenis; return l && !l.__dead ? l : null; }
  function killLenis() {
    var l = window.__cyrusLenis; if (!l || l.__dead) return;
    try { l.destroy(); } catch (e) {}
    l.__dead = true;
    l.raf = l.stop = l.start = function () {};
    l.scrollTo = function (t) {
      if (typeof t === 'number') window.scrollTo(0, t);
      else if (t && t.scrollIntoView) t.scrollIntoView({ block: 'start' });
    };
    html.classList.remove('lenis', 'lenis-smooth', 'lenis-stopped', 'lenis-scrolling');
  }
  function scrollTop() {
    var l = lenis();
    if (l) l.scrollTo(0, { duration: 1.4 });
    else window.scrollTo({ top: 0, behavior: P.calm ? 'auto' : 'smooth' });
  }
  function lockScroll(on) {
    var l = lenis(); if (l) { if (on) l.stop(); else l.start(); }
    doc.body.style.overflow = on ? 'hidden' : '';
  }

  /* ---------- sound (generated with Web Audio, no files) ---------- */
  var Sfx = (function () {
    var ctx = null, out = null, unlocked = false, lastHover = 0;
    function ensure() {
      if (ctx || !unlocked) return ctx;
      var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null;
      try {
        ctx = new AC(); out = ctx.createGain(); out.gain.value = 0.7;
        var comp = ctx.createDynamicsCompressor(); out.connect(comp); comp.connect(ctx.destination);
      } catch (e) { ctx = null; }
      return ctx;
    }
    function ready() { if (!P.sfx) return null; var c = ensure(); if (c && c.state === 'suspended') c.resume(); return c; }
    function tone(f, dur, type, vol, delay, to) {
      var c = ready(); if (!c) return;
      var t = c.currentTime + (delay || 0), o = c.createOscillator(), g = c.createGain();
      o.type = type || 'sine'; o.frequency.setValueAtTime(f, t);
      if (to) o.frequency.exponentialRampToValueAtTime(to, t + dur);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol, t + 0.008);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g); g.connect(out); o.start(t); o.stop(t + dur + 0.03);
    }
    function air(dur, vol, f0, f1) {
      var c = ready(); if (!c) return;
      var t = c.currentTime, n = Math.floor(c.sampleRate * dur), b = c.createBuffer(1, n, c.sampleRate), d = b.getChannelData(0);
      for (var i = 0; i < n; i++) d[i] = Math.random() * 2 - 1;
      var s = c.createBufferSource(), f = c.createBiquadFilter(), g = c.createGain();
      s.buffer = b; f.type = 'bandpass'; f.Q.value = 1.1;
      f.frequency.setValueAtTime(f0, t); f.frequency.exponentialRampToValueAtTime(f1, t + dur);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol, t + dur * 0.35);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      s.connect(f); f.connect(g); g.connect(out); s.start(t); s.stop(t + dur + 0.03);
    }
    return {
      unlock: function () { if (unlocked) return; unlocked = true; ensure(); },
      hover: function () { var n = performance.now(); if (n - lastHover < 80) return; lastHover = n; tone(2400, 0.045, 'sine', 0.010); },
      tick: function () { tone(1500, 0.05, 'sine', 0.028); },
      click: function () { tone(620, 0.09, 'triangle', 0.045, 0, 420); },
      add: function () { tone(784, 0.4, 'sine', 0.06); tone(1175, 0.5, 'sine', 0.045, 0.09); tone(1568, 0.7, 'sine', 0.03, 0.18); },
      open: function () { air(0.32, 0.05, 500, 2600); },
      close: function () { air(0.26, 0.04, 2200, 450); },
      on: function () { tone(880, 0.09, 'sine', 0.05); tone(1320, 0.12, 'sine', 0.04, 0.07); },
      off: function () { tone(1100, 0.08, 'sine', 0.04); tone(700, 0.12, 'sine', 0.04, 0.07); },
      success: function () { tone(1046, 0.22, 'sine', 0.05); tone(1568, 0.4, 'sine', 0.04, 0.08); }
    };
  })();

  function initSfx() {
    var unlock = function () { Sfx.unlock(); };
    addEventListener('pointerdown', unlock, { capture: true, passive: true });
    addEventListener('keydown', unlock, true);
    if (fine) doc.addEventListener('pointerover', function (e) {
      var t = e.target.closest && e.target.closest('.btn, .icon-btn, .add, .tab, .size, .opt, .hdr-nav a, .card-media, .cat, .chip, .srch-r, .dock-btn, .sw, .seg button, .share-btn, .sharep-i');
      if (!t || (e.relatedTarget && t.contains(e.relatedTarget))) return;
      Sfx.hover();
    });
    doc.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('button, a, summary, [role="tab"]'); if (!t) return;
      if (t.hasAttribute('data-add') || t.hasAttribute('data-bb-add') || t.hasAttribute('data-pref') || t.id === 'sfxBtn' ||
          t.hasAttribute('data-search-open') || t.hasAttribute('data-share') || t.id === 'a11yBtn' || t.hasAttribute('data-a11y-open')) return;
      if (t.id === 'gateYes') { Sfx.success(); return; }
      if (t.matches('.tab, .size, .opt, .seg button, .hero-dot, .chip')) Sfx.tick(); else Sfx.click();
    }, true);
    if (!('MutationObserver' in window)) return;
    var cc = $('#cartCount');
    if (cc) new MutationObserver(function (recs) {
      var fresh = recs.some(function (r) { return !/\bbump\b/.test(r.oldValue || '') && cc.classList.contains('bump'); });
      if (fresh) { Sfx.add(); toast('Added to your basket'); }
    }).observe(cc, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    var dr = $('#drawer'), drOn = false;
    if (dr) new MutationObserver(function () {
      var on = dr.classList.contains('is-on'); if (on === drOn) return; drOn = on;
      if (on) Sfx.open(); else Sfx.close();
    }).observe(dr, { attributes: true, attributeFilter: ['class'] });
    var mnOn = false;
    new MutationObserver(function () {
      var on = doc.body.classList.contains('menu-open'); if (on === mnOn) return; mnOn = on;
      if (on) Sfx.open(); else Sfx.close();
    }).observe(doc.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- ambient background: falling saffron and gold dust ---------- */
  var Bg = (function () {
    var cv, cx, W = 0, H = 0, D = 1, parts = [], raf = 0, running = false, mx = -9999, my = -9999, sv = 0, ly = 0, lt = 0;
    var gold, ivory;
    function sprite(stops) {
      var c = doc.createElement('canvas'); c.width = c.height = 64;
      var s = c.getContext('2d'), g = s.createRadialGradient(32, 32, 0, 32, 32, 32);
      stops.forEach(function (st) { g.addColorStop(st[0], st[1]); });
      s.fillStyle = g; s.fillRect(0, 0, 64, 64); return c;
    }
    function make(anywhere) {
      var z = Math.random(), r = Math.random();
      var kind = r < 0.15 ? 2 : (r < 0.38 ? 1 : 0);
      return {
        x: Math.random() * W, y: anywhere ? Math.random() * H : -24 - Math.random() * 60, z: z, kind: kind,
        r: 0.6 + z * 2.3, len: 7 + z * 11, a: Math.random() * 6.283, va: (Math.random() - 0.5) * 0.02,
        vy: 0.14 + z * 0.5, sw: Math.random() * 6.283, sws: 0.004 + Math.random() * 0.01, amp: 0.15 + z * 0.5,
        o: 0.16 + z * 0.5, tw: Math.random() * 6.283, vx: 0
      };
    }
    function size() {
      if (!cv) return;
      D = Math.min(window.devicePixelRatio || 1, 1.5); W = innerWidth; H = innerHeight;
      cv.width = Math.round(W * D); cv.height = Math.round(H * D);
      cx.setTransform(D, 0, 0, D, 0, 0);
      var n = Math.round(Math.min(110, Math.max(26, W * H / 15000)));
      while (parts.length < n) parts.push(make(true));
      parts.length = n;
    }
    function frame(t) {
      if (!running) return;
      var dt = lt ? Math.min(2.5, (t - lt) / 16.67) : 1; lt = t;
      cx.clearRect(0, 0, W, H);
      if (mx > -999) {
        var lg = cx.createRadialGradient(mx, my, 0, mx, my, 280);
        lg.addColorStop(0, 'rgba(227,163,59,0.075)'); lg.addColorStop(1, 'rgba(227,163,59,0)');
        cx.fillStyle = lg; cx.fillRect(mx - 280, my - 280, 560, 560);
      }
      var push = sv * 0.06; sv *= 0.86;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.sw += p.sws * dt; p.tw += 0.03 * dt;
        p.x += (Math.sin(p.sw) * p.amp * 0.5 + p.vx) * dt; p.vx *= 0.94;
        p.y += p.vy * dt - push * (0.25 + p.z * 0.6);
        var dx = p.x - mx, dy = p.y - my, d2 = dx * dx + dy * dy;
        if (d2 < 16900) { var d = Math.sqrt(d2) || 1, f = (1 - d / 130); p.vx += dx / d * f * 0.5; p.y += dy / d * f * 0.8; }
        if (p.y > H + 30) { parts[i] = make(false); continue; }
        if (p.y < -90) p.y = H + 20;
        if (p.x < -30) p.x = W + 20; else if (p.x > W + 30) p.x = -20;
        var o = p.o * (0.72 + 0.28 * Math.sin(p.tw));
        if (p.kind === 2) {
          p.a += p.va * dt;
          cx.save(); cx.translate(p.x, p.y); cx.rotate(p.a);
          cx.strokeStyle = 'rgba(196,58,24,' + (o * 0.95).toFixed(3) + ')';
          cx.lineWidth = 0.6 + p.z * 1.0; cx.lineCap = 'round';
          cx.beginPath(); cx.moveTo(-p.len / 2, 0); cx.quadraticCurveTo(0, p.len * 0.2, p.len / 2, 0); cx.stroke();
          cx.restore();
        } else {
          var s = p.r * 6; cx.globalAlpha = p.kind === 1 ? o * 0.6 : o;
          cx.drawImage(p.kind === 1 ? ivory : gold, p.x - s / 2, p.y - s / 2, s, s);
          cx.globalAlpha = 1;
        }
      }
      raf = requestAnimationFrame(frame);
    }
    function want() { return !!cx && P.bg && !P.calm && !doc.hidden; }
    function start() { if (running) return; running = true; lt = 0; cv.classList.add('is-on'); raf = requestAnimationFrame(frame); }
    function stop() { running = false; cancelAnimationFrame(raf); if (cv) cv.classList.remove('is-on'); }
    function update() { if (want()) start(); else stop(); }
    function init() {
      cv = $('#fxBg'); if (!cv || !cv.getContext) return;
      cx = cv.getContext('2d'); if (!cx) return;
      gold = sprite([[0, 'rgba(255,218,150,1)'], [0.22, 'rgba(240,182,84,0.6)'], [1, 'rgba(227,163,59,0)']]);
      ivory = sprite([[0, 'rgba(255,246,230,0.95)'], [0.3, 'rgba(242,236,226,0.35)'], [1, 'rgba(242,236,226,0)']]);
      size(); ly = scrollY;
      var rt; addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(size, 150); });
      addEventListener('scroll', function () { var y = scrollY; sv += Math.max(-40, Math.min(40, y - ly)); ly = y; }, { passive: true });
      if (fine) {
        addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; }, { passive: true });
        html.addEventListener('pointerleave', function () { mx = my = -9999; });
      }
      doc.addEventListener('visibilitychange', update);
      update();
    }
    return { init: init, update: update };
  })();

  /* ---------- header progress + back to top ---------- */
  function initScrollUi() {
    var hdr = $('#hdr'), top = $('#topBtn'), ticking = false, shown = null;
    function upd() {
      var max = Math.max(1, html.scrollHeight - innerHeight), p = Math.min(1, Math.max(0, scrollY / max));
      if (hdr) hdr.style.setProperty('--p', p.toFixed(4));
      if (top) {
        top.style.setProperty('--p', p.toFixed(4));
        var on = scrollY > innerHeight * 0.9;
        if (on !== shown) {
          shown = on; top.classList.toggle('is-on', on);
          if (on) { top.removeAttribute('tabindex'); top.removeAttribute('aria-hidden'); }
          else { top.setAttribute('tabindex', '-1'); top.setAttribute('aria-hidden', 'true'); }
        }
      }
      ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    addEventListener('resize', upd); upd();
    if (top) top.addEventListener('click', function () {
      scrollTop();
      setTimeout(function () { var m = $('#main'); if (m) m.focus({ preventScroll: true }); }, P.calm ? 0 : 1000);
    });
  }

  /* ---------- recently viewed ---------- */
  var RV = {
    key: 'cyrus-recent',
    list: function () { try { var l = JSON.parse(localStorage.getItem(this.key) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } },
    save: function (l) { try { localStorage.setItem(this.key, JSON.stringify(l.slice(0, 12))); } catch (e) {} },
    clear: function () { try { localStorage.removeItem(this.key); } catch (e) {} }
  };
  function recordView() {
    var pdp = $('[data-pdp]'); if (!pdp) return null;
    var name = txt($('.pdp-t', pdp)); if (!name) return null;
    var img = $('.stage-img', pdp), st = $('.stage', pdp), crumbs = $$('.crumbs a', pdp);
    var r = {
      u: location.pathname, t: name, s: txt($('[data-size-label]', pdp)), p: txt($('[data-price-el]', pdp)),
      i: img ? sized(img.getAttribute('src') || '', 600) : '', c: st ? st.style.getPropertyValue('--tint').trim() : '',
      k: crumbs.length > 1 ? txt(crumbs[crumbs.length - 1]) : ''
    };
    var l = RV.list().filter(function (x) { return x && x.t !== r.t; });
    l.unshift(r); RV.save(l); return r;
  }
  function rvCard(r, i) {
    var u = esc(r.u);
    return '<article class="card rv-card" style="--i:' + i + '">' +
      '<a class="card-media" href="' + u + '" tabindex="-1" aria-hidden="true"><span class="stage" style="--tint:' + esc(r.c || '#3a2410') + '"><span class="stage-glow"></span><span class="stage-floor"></span>' +
      (r.i ? '<img class="stage-img is-loaded" src="' + esc(r.i) + '" alt="" loading="lazy" width="1000" height="1333">' : '') + '</span></a>' +
      '<div class="card-body"><p class="card-k"><span>' + esc(r.k || '') + '</span><span>' + esc(r.s || '') + '</span></p>' +
      '<h3 class="card-t"><a href="' + u + '">' + esc(r.t) + '</a></h3>' +
      '<div class="card-ft"><span class="price">' + esc(r.p || '') + '</span><a class="add" href="' + u + '" aria-label="View ' + esc(r.t) + '">View</a></div></div></article>';
  }
  function initRecent() {
    var cur = recordView();
    var list = RV.list().filter(function (x) { return x && x.t && (!cur || x.t !== cur.t); });
    var anchor = null, before = false;
    if (cur) anchor = $('.related');
    else if (C.template === 'index') { anchor = $('.promises'); before = true; if (list.length < 2) return; }
    if (!anchor || !list.length) return;
    var sec = doc.createElement('section');
    sec.className = 'sec rv'; sec.setAttribute('aria-labelledby', 'rvH');
    sec.innerHTML = '<div class="wrap"><div class="sec-head"><div><p class="eyebrow">Pick up where you left off</p><h2 class="h2" id="rvH">Recently viewed</h2></div>' +
      '<div class="rv-acts"><button class="rv-clear" type="button">Clear history</button><div class="rail-nav">' +
      '<button class="icon-btn icon-btn-line" type="button" data-rv-prev aria-label="Previous">' + ICON.prev + '</button>' +
      '<button class="icon-btn icon-btn-line" type="button" data-rv-next aria-label="Next">' + ICON.next + '</button></div></div></div></div>' +
      '<div class="rail" data-rv-rail>' + list.map(rvCard).join('') + '</div>';
    anchor.parentNode.insertBefore(sec, before ? anchor : anchor.nextSibling);
    var rail = $('[data-rv-rail]', sec);
    var step = function () { var c = $('.card', rail); return c ? c.getBoundingClientRect().width + 22 : 300; };
    $('[data-rv-prev]', sec).addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    $('[data-rv-next]', sec).addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    $('.rv-clear', sec).addEventListener('click', function () {
      RV.clear(); if (cur) RV.save([cur]);
      sec.classList.add('is-leaving'); toast('Viewing history cleared');
      setTimeout(function () { sec.remove(); }, 500);
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } }, { rootMargin: '0px 0px -10% 0px' });
      io.observe(sec);
    } else sec.classList.add('is-in');
  }

  /* ---------- quick search ---------- */
  var TINTS = { spirits: '#5a3a0c', liqueurs: '#5a0f14', wine: '#4a0f1c', beer: '#5a3a0c', tea: '#2f3a14', coffee: '#2a1f18' };
  var Search = (function () {
    var box, input, body, live, open = false, last = null, ctl = null, timer = 0, items = [], sel = -1, qn = 0;
    function row(r, i) {
      return '<a class="srch-r" role="option" id="sr' + i + '" href="' + esc(r.url) + '" style="--i:' + i + '" aria-selected="false">' +
        '<span class="stage" style="--tint:' + esc(r.tint || '#3a2410') + '"><span class="stage-glow"></span>' + (r.img ? '<img src="' + esc(r.img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="srch-n"><b>' + esc(r.title) + '</b>' + (r.sub ? '<small>' + esc(r.sub) + '</small>' : '') + '</span>' +
        '<span class="srch-p">' + esc(r.price || '') + '</span></a>';
    }
    function collect() { items = $$('.srch-r', body); sel = -1; input.removeAttribute('aria-activedescendant'); }
    function idle() {
      var col = C.collection || (ROOT + 'collections/all');
      var chips = [['Spirits', 'spirits'], ['Liqueurs', 'liqueurs'], ['Wine', 'wine'], ['Beer', 'beer'], ['Tea', 'tea'], ['Coffee', 'coffee']];
      var h = '<p class="srch-h">Browse the cellar</p><div class="srch-chips">' + chips.map(function (c) { return '<a class="chip" href="' + esc(col + '#' + c[1]) + '">' + c[0] + '</a>'; }).join('') + '</div>';
      var rv = RV.list().slice(0, 4);
      if (rv.length) h += '<p class="srch-h">Recently viewed</p><div role="listbox" id="srchList" aria-label="Recently viewed">' +
        rv.map(function (r, i) { return row({ url: r.u, title: r.t, sub: r.s, price: r.p, img: sized(r.i, 160), tint: r.c }, i); }).join('') + '</div>';
      body.innerHTML = h; collect(); input.setAttribute('aria-expanded', rv.length ? 'true' : 'false');
    }
    function query() {
      var q = input.value.trim(); if (!q) { idle(); if (live) live.textContent = ''; return; }
      var my = ++qn;
      if (ctl) { try { ctl.abort(); } catch (e) {} }
      ctl = ('AbortController' in window) ? new AbortController() : null;
      body.setAttribute('aria-busy', 'true');
      var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
      fetch(url, ctl ? { signal: ctl.signal, headers: { Accept: 'application/json' } } : { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (my !== qn) return;
          var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          var map = {}, rows = [];
          ps.forEach(function (p) {
            var parts = String(p.title || '').split(' · '), name = parts[0];
            var price = Number(p.price_min || p.price || 0);
            var type = String(p.type || '');
            if (map[name]) { var m = map[name]; m.n++; if (price && price < m.min) m.min = price; return; }
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            var r = { url: p.url, title: name, sub: type, min: price, n: 1, img: img ? sized(img, 160) : '', tint: TINTS[type.toLowerCase()] || '' };
            map[name] = r; rows.push(r);
          });
          rows.forEach(function (r) { r.price = r.min ? (r.n > 1 ? 'from ' : '') + money(r.min) : ''; });
          var all = ROOT + 'search?type=product&q=' + encodeURIComponent(q);
          if (!rows.length) {
            body.innerHTML = '<p class="srch-empty">Nothing matches “' + esc(q) + '”. Try gin, wine or tea.</p>';
            items = []; input.setAttribute('aria-expanded', 'false');
            if (live) live.textContent = 'No products found';
            return;
          }
          body.innerHTML = '<p class="srch-h">Products</p><div role="listbox" id="srchList" aria-label="Search results">' + rows.slice(0, 6).map(row).join('') + '</div>' +
            '<a class="srch-all" href="' + esc(all) + '"><span>See all results for “' + esc(q) + '”</span><span aria-hidden="true">→</span></a>';
          collect(); input.setAttribute('aria-expanded', 'true');
          if (live) live.textContent = Math.min(rows.length, 6) + (rows.length === 1 ? ' product found' : ' products found') + '. Use the arrow keys to choose.';
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          body.innerHTML = '<p class="srch-empty">Quick search isn’t available right now. Press Enter to search the shop.</p>';
        })
        .then(function () { if (my === qn) body.removeAttribute('aria-busy'); });
    }
    function mark(i) {
      items.forEach(function (it, k) { it.setAttribute('aria-selected', String(k === i)); });
      sel = i;
      if (i >= 0 && items[i]) { input.setAttribute('aria-activedescendant', items[i].id); items[i].scrollIntoView({ block: 'nearest' }); Sfx.tick(); }
      else input.removeAttribute('aria-activedescendant');
    }
    function show(v) {
      if (!box || v === open) return; open = v;
      if (v) {
        last = doc.activeElement; box.hidden = false; lockScroll(true);
        input.value = ''; idle(); if (live) live.textContent = '';
        requestAnimationFrame(function () { box.classList.add('is-on'); input.focus(); });
        Sfx.open();
      } else {
        box.classList.remove('is-on'); lockScroll(false);
        setTimeout(function () { if (!open) box.hidden = true; }, 420);
        Sfx.close();
        if (last && last.focus && doc.contains(last)) last.focus({ preventScroll: true });
      }
    }
    function init() {
      box = $('#srch'); if (!box) return;
      input = $('#srchIn', box); body = $('#srchBody', box); live = $('#srchLive', box);
      doc.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-search-open]');
        if (a) { e.preventDefault(); show(true); }
      });
      $$('[data-srch-close]', box).forEach(function (b) { b.addEventListener('click', function () { show(false); }); });
      box.addEventListener('pointerdown', function (e) { if (e.target === box) show(false); });
      body.addEventListener('click', function (e) { if (e.target.closest('a')) { open = false; box.classList.remove('is-on'); box.hidden = true; lockScroll(false); } });
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(query, 170); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); if (items.length) mark((sel + 1) % items.length); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); if (items.length) mark(sel <= 0 ? items.length - 1 : sel - 1); }
        else if (e.key === 'Enter' && sel >= 0 && items[sel]) { e.preventDefault(); location.href = items[sel].href; }
      });
      $('form', box).addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); show(false); return; }
        if (e.key !== 'Tab') return;
        var f = $$('input:not([type="hidden"]), button, a[href]', box).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }
    return { init: init, show: show, isOpen: function () { return open; } };
  })();

  /* ---------- share ---------- */
  var Share = (function () {
    var pop, open = false, last = null, data = null;
    function get(b) {
      var url = b.getAttribute('data-share-url') || (location.origin + location.pathname);
      var title = b.getAttribute('data-share-title') || doc.title;
      return { url: url, title: title, text: b.getAttribute('data-share-text') || title };
    }
    function place() {
      if (!open || !last) return;
      if (innerWidth <= 620) { pop.classList.add('is-sheet'); pop.style.left = ''; pop.style.top = ''; return; }
      pop.classList.remove('is-sheet');
      var r = last.getBoundingClientRect(), w = pop.offsetWidth, h = pop.offsetHeight;
      var x = Math.min(innerWidth - w - 16, Math.max(16, r.right - w)), y = r.bottom + 10;
      if (y + h > innerHeight - 16) y = Math.max(16, r.top - h - 10);
      pop.style.left = Math.round(x) + 'px'; pop.style.top = Math.round(y) + 'px';
    }
    function copy(text) {
      var done = function () {
        Sfx.success(); toast('Link copied. Paste it anywhere to share.');
        var cb = pop && $('[data-share-copy]', pop);
        if (cb) { cb.textContent = 'Copied'; setTimeout(function () { cb.textContent = 'Copy'; }, 1800); }
      };
      var fallback = function () {
        var i = pop && $('[data-share-input]', pop), tmp = null;
        if (!i || !open) { tmp = doc.createElement('textarea'); tmp.value = text; tmp.setAttribute('readonly', ''); tmp.style.cssText = 'position:fixed;opacity:0'; doc.body.appendChild(tmp); i = tmp; }
        i.select();
        try { doc.execCommand('copy'); done(); } catch (e) { toast('Select the link and copy it'); }
        if (tmp) tmp.remove();
      };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(done, fallback); else fallback();
    }
    function show(b) {
      last = b; open = true;
      var enc = encodeURIComponent, u = enc(data.url);
      var set = function (k, h) { var a = $('[data-sh="' + k + '"]', pop); if (a) a.href = h; };
      set('wa', 'https://wa.me/?text=' + enc(data.text + ' ' + data.url));
      set('fb', 'https://www.facebook.com/sharer/sharer.php?u=' + u);
      set('x', 'https://twitter.com/intent/tweet?text=' + enc(data.text) + '&url=' + u);
      set('mail', 'mailto:?subject=' + enc(data.title) + '&body=' + enc(data.text + '\n\n' + data.url));
      var inp = $('[data-share-input]', pop); if (inp) inp.value = data.url;
      var more = $('[data-share-more]', pop); if (more) more.hidden = !navigator.share;
      pop.hidden = false; place();
      requestAnimationFrame(function () { pop.classList.add('is-on'); var f = $('.sharep-i', pop); if (f) f.focus({ preventScroll: true }); });
      b.setAttribute('aria-expanded', 'true'); Sfx.open();
    }
    function hide(noFocus) {
      if (!open) return; open = false;
      pop.classList.remove('is-on');
      setTimeout(function () { if (!open) pop.hidden = true; }, 400);
      if (last) { last.setAttribute('aria-expanded', 'false'); if (!noFocus && last.focus) last.focus({ preventScroll: true }); }
      Sfx.close();
    }
    function trigger(b) {
      data = get(b);
      var coarse = window.matchMedia('(pointer: coarse)').matches;
      if (navigator.share && coarse) { navigator.share(data).then(function () { Sfx.success(); }).catch(function () {}); return; }
      if (!pop) { copy(data.url); return; }
      if (open && last === b) { hide(); return; }
      if (open) hide(true);
      show(b);
    }
    function init() {
      pop = $('#sharep');
      doc.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-share]');
        if (b) { e.preventDefault(); trigger(b); }
      });
      if (!pop) return;
      $$('[data-share-close]', pop).forEach(function (b) { b.addEventListener('click', function () { hide(); }); });
      var cb = $('[data-share-copy]', pop); if (cb) cb.addEventListener('click', function () { if (data) copy(data.url); });
      var mb = $('[data-share-more]', pop); if (mb) mb.addEventListener('click', function () { if (navigator.share && data) navigator.share(data).then(function () { hide(true); }).catch(function () {}); });
      $$('a[data-sh]', pop).forEach(function (a) { a.addEventListener('click', function () { Sfx.success(); setTimeout(function () { hide(true); }, 150); }); });
      doc.addEventListener('pointerdown', function (e) { if (open && !pop.contains(e.target) && !(last && last.contains(e.target))) hide(true); });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) hide(); });
      addEventListener('resize', place);
      addEventListener('scroll', place, { passive: true });
    }
    return { init: init };
  })();

  /* ---------- product page: share button + quick-add bar ---------- */
  function initPdp() {
    var pdp = $('[data-pdp]'); if (!pdp) return;
    var name = txt($('.pdp-t', pdp));
    var row = $('.pdp-price', pdp);
    if (row && !$('.share-btn', row)) {
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'share-btn';
      b.setAttribute('data-share', ''); b.setAttribute('aria-haspopup', 'dialog'); b.setAttribute('aria-expanded', 'false');
      b.setAttribute('data-share-title', name + ' · Cyrus');
      b.setAttribute('data-share-text', 'Have a look at ' + name + ' from Cyrus');
      b.innerHTML = ICON.share + '<span>Share</span>';
      row.appendChild(b);
    }
    var buy = $('.pdp-buy', pdp), add = $('[data-add]', pdp);
    if (!buy || !add || !('IntersectionObserver' in window)) return;
    var img = $('.stage-img', pdp), st = $('.stage', pdp), priceEl = $('[data-price-el]', pdp), sizeEl = $('[data-size-label]', pdp);
    var bar = doc.createElement('div');
    bar.className = 'buybar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Quick add to basket');
    bar.setAttribute('aria-hidden', 'true'); bar.inert = true;
    bar.innerHTML = '<div class="buybar-in"><span class="stage" style="--tint:' + esc(st ? st.style.getPropertyValue('--tint') : '') + '"><span class="stage-glow"></span>' +
      (img ? '<img src="' + esc(sized(img.getAttribute('src') || '', 200)) + '" alt="">' : '') + '</span>' +
      '<span class="buybar-t"><b>' + esc(name) + '</b><span data-bb-meta></span></span>' +
      '<button class="btn btn-gold" type="button" data-bb-add>' + ICON.bag + '<span data-bb-label>Add to basket</span></button></div>';
    doc.body.appendChild(bar);
    var meta = $('[data-bb-meta]', bar), bbAdd = $('[data-bb-add]', bar), lbl = $('[data-bb-label]', bar), bi = $('img', bar);
    function upd() {
      meta.textContent = [txt(priceEl), txt(sizeEl)].filter(Boolean).join(' · ');
      bbAdd.disabled = add.disabled;
      lbl.textContent = add.disabled ? (txt($('.add-t', add)) || 'Sold out') : 'Add to basket';
      var src = img && img.getAttribute('src');
      if (bi && src && bi.getAttribute('data-src') !== src) { bi.setAttribute('data-src', src); bi.src = sized(src, 200); }
    }
    upd();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(upd);
      [priceEl, sizeEl, img].forEach(function (n) { if (n) mo.observe(n, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['src'] }); });
      new MutationObserver(function () {
        upd();
        bbAdd.classList.toggle('is-busy', add.classList.contains('is-busy'));
        bbAdd.classList.toggle('is-done', add.classList.contains('is-done'));
      }).observe(add, { attributes: true, attributeFilter: ['class', 'disabled'] });
    }
    bbAdd.addEventListener('click', function () { if (!add.disabled) add.click(); });
    var on = false;
    function set(v) {
      if (v === on) return; on = v;
      bar.classList.toggle('is-on', v); bar.inert = !v; bar.setAttribute('aria-hidden', String(!v));
      html.classList.toggle('has-buybar', v);
    }
    new IntersectionObserver(function (en) { var e = en[0]; set(!e.isIntersecting && e.boundingClientRect.top < 0); }).observe(buy);
  }

  /* ---------- accessibility panel ---------- */
  function onPref(k) {
    if ((k === 'calm' || k === 'all') && P.calm) killLenis();
    if (k === 'bg' || k === 'calm' || k === 'all') Bg.update();
  }
  function initPanel() {
    var btn = $('#a11yBtn'), pan = $('#a11y'), sfxBtn = $('#sfxBtn'), open = false, last = null;
    function sync() {
      if (pan) {
        $$('[data-ts]', pan).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-ts') === P.ts)); });
        $$('[data-pref]', pan).forEach(function (b) { b.setAttribute('aria-checked', String(!!P[b.getAttribute('data-pref')])); });
      }
      if (sfxBtn) { sfxBtn.setAttribute('aria-pressed', String(!!P.sfx)); sfxBtn.setAttribute('aria-label', P.sfx ? 'Mute sound effects' : 'Turn on sound effects'); }
    }
    function setPref(k, v) {
      var was = P[k];
      if (k === 'sfx' && was && !v) Sfx.off();
      P[k] = v; save(); applyPrefs(); sync(); onPref(k);
      if (k === 'sfx') { if (v) Sfx.on(); toast(v ? 'Sound effects on' : 'Sound effects off'); }
      else if (k !== 'ts') { if (v) Sfx.on(); else Sfx.off(); }
      if (k === 'calm' && !v) toast('Animations are back on. Smooth scrolling returns on the next page.');
    }
    if (sfxBtn) sfxBtn.addEventListener('click', function () { Sfx.unlock(); setPref('sfx', !P.sfx); });
    sync();
    if (!btn || !pan) return;
    function show(v) {
      if (v === open) return; open = v; btn.setAttribute('aria-expanded', String(v));
      if (v) {
        last = doc.activeElement; pan.hidden = false;
        requestAnimationFrame(function () { pan.classList.add('is-on'); var f = $('[data-ts][aria-pressed="true"]', pan) || $('button', pan); if (f) f.focus({ preventScroll: true }); });
        Sfx.open();
      } else {
        pan.classList.remove('is-on');
        setTimeout(function () { if (!open) pan.hidden = true; }, 550);
        Sfx.close();
        if (last && last.focus && doc.contains(last)) last.focus({ preventScroll: true });
      }
    }
    btn.addEventListener('click', function () { show(!open); });
    doc.addEventListener('click', function (e) { var o = e.target.closest && e.target.closest('[data-a11y-open]'); if (o) { e.preventDefault(); show(true); } });
    $$('[data-a11y-close]', pan).forEach(function (b) { b.addEventListener('click', function () { show(false); }); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) show(false); });
    doc.addEventListener('pointerdown', function (e) {
      if (open && !pan.contains(e.target) && !btn.contains(e.target) && !(e.target.closest && e.target.closest('[data-a11y-open]'))) show(false);
    });
    $$('[data-ts]', pan).forEach(function (b) {
      b.addEventListener('click', function () { setPref('ts', +b.getAttribute('data-ts')); Sfx.tick(); });
    });
    $$('[data-pref]', pan).forEach(function (b) {
      b.addEventListener('click', function () { var k = b.getAttribute('data-pref'); setPref(k, !P[k]); });
    });
    var rs = $('[data-a11y-reset]', pan);
    if (rs) rs.addEventListener('click', function () {
      for (var k in DEF) P[k] = DEF[k];
      save(); applyPrefs(); sync(); onPref('all'); Sfx.on(); toast('Settings reset');
    });
  }

  /* ---------- keyboard shortcuts ---------- */
  function initKeys() {
    doc.addEventListener('keydown', function (e) {
      if (!P.keys || e.ctrlKey || e.metaKey || e.altKey || e.defaultPrevented) return;
      if ($('#gate') && !html.classList.contains('age-ok')) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (Search.isOpen()) return;
      var k = e.key;
      if (k === '/') { e.preventDefault(); Search.show(true); }
      else if (k === 'b' || k === 'B') { var c = $('#cartOpen'); if (c) { e.preventDefault(); c.click(); } }
      else if (k === 't' || k === 'T') { e.preventDefault(); scrollTop(); }
      else if (k === '?') { var a = $('#a11yBtn'); if (a && a.getAttribute('aria-expanded') !== 'true') { e.preventDefault(); a.click(); } }
    });
  }

  /* ---------- navigation state ---------- */
  function initNav() {
    function mark() {
      $$('.hdr-nav a, .menu-in a').forEach(function (a) {
        var on = false;
        try { var u = new URL(a.href, location.href); on = u.pathname === location.pathname && (u.hash || '') === (location.hash || ''); } catch (e) {}
        if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
      });
    }
    mark(); addEventListener('hashchange', mark);
  }

  /* ---------- micro-interactions ---------- */
  function initFx() {
    function loaded(img) {
      if (img.classList.contains('is-loaded')) return;
      if (img.complete && img.naturalWidth) { img.classList.add('is-loaded'); return; }
      var done = function () { img.classList.add('is-loaded'); };
      img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
    }
    $$('.stage-img').forEach(loaded);
    setTimeout(function () { $$('.stage-img').forEach(function (i) { i.classList.add('is-loaded'); }); }, 4000);

    doc.addEventListener('pointerdown', function (e) {
      if (P.calm) return;
      var b = e.target.closest && e.target.closest('.btn, .add, .share-btn');
      if (!b || b.disabled) return;
      var r = b.getBoundingClientRect(), d = Math.max(r.width, r.height) * 2.2, s = doc.createElement('span');
      s.className = 'ripple'; s.style.width = s.style.height = d + 'px';
      s.style.left = (e.clientX - r.left - d / 2) + 'px'; s.style.top = (e.clientY - r.top - d / 2) + 'px';
      b.appendChild(s); setTimeout(function () { s.remove(); }, 800);
    });

    if (!fine) return;
    var mag = null, tilt = null, pending = null, rafId = 0;
    function reset() {
      if (mag) { mag.style.translate = ''; mag = null; }
      if (tilt) { tilt.style.transform = ''; tilt.classList.remove('is-tilt'); tilt = null; }
    }
    function run() {
      rafId = 0; var e = pending; if (!e) return;
      if (P.calm) { reset(); return; }
      var tg = e.target && e.target.closest ? e.target : null;
      var m = tg && tg.closest('.btn, .icon-btn, .dock-btn, .share-btn');
      if (mag && mag !== m) { mag.style.translate = ''; mag = null; }
      if (m && !m.disabled) {
        mag = m;
        var r = m.getBoundingClientRect(), x = (e.clientX - r.left - r.width / 2) / r.width, y = (e.clientY - r.top - r.height / 2) / r.height;
        var k = m.classList.contains('btn') ? 8 : 5;
        m.style.translate = (x * k).toFixed(1) + 'px ' + (y * k * 0.8).toFixed(1) + 'px';
      }
      var s = tg && tg.closest('.card-media .stage, .cat .stage, .pdp-media .stage');
      if (tilt && tilt !== s) { tilt.style.transform = ''; tilt.classList.remove('is-tilt'); tilt = null; }
      if (s) {
        tilt = s; s.classList.add('is-tilt');
        var q = s.getBoundingClientRect(), px = (e.clientX - q.left) / q.width, py = (e.clientY - q.top) / q.height;
        var amt = s.closest('.pdp-media') ? 4 : 7;
        s.style.transform = 'perspective(900px) rotateX(' + ((0.5 - py) * amt).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * amt).toFixed(2) + 'deg)';
        s.style.setProperty('--sx', (px * 100).toFixed(1) + '%'); s.style.setProperty('--sy', (py * 100).toFixed(1) + '%');
      }
    }
    doc.addEventListener('pointermove', function (e) { pending = e; if (!rafId) rafId = requestAnimationFrame(run); }, { passive: true });
    html.addEventListener('pointerleave', reset);

    var hero = $('#hero'), slides = hero && $('.hero-slides', hero);
    if (hero && slides) {
      hero.addEventListener('pointermove', function (e) {
        if (P.calm) return;
        var r = hero.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        slides.style.translate = (x * -20).toFixed(1) + 'px ' + (y * -14).toFixed(1) + 'px';
        slides.style.rotate = (x * 2).toFixed(2) + 'deg';
      }, { passive: true });
      hero.addEventListener('pointerleave', function () { slides.style.translate = ''; slides.style.rotate = ''; });
    }
  }

  function boot() {
    initSfx(); Bg.init(); initScrollUi(); initPanel(); Search.init(); Share.init();
    initPdp(); initRecent(); initKeys(); initNav(); initFx();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
